module.exports = __webpack_public_path__ + "static/mutex-5f94ccbf7f88d67c18b476d460677d91.png";